import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmationDialogComponent } from './confirmation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {

  constructor(private modalService: NgbModal) { }

  public confirm(
    title: string,
    message: string,
    btnOkText: string = 'Yes',
    btnCancelText: string = 'No',
    dialogSize: 'sm'|'lg' = 'sm',
    hasInputText?: boolean,
    inputTextVal?: string): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize });
    modalRef.componentInstance.title = title.toUpperCase();
    modalRef.componentInstance.message = message.toUpperCase();
    modalRef.componentInstance.btnOkText = btnOkText.toUpperCase();
    modalRef.componentInstance.btnCancelText = btnCancelText.toUpperCase();
    modalRef.componentInstance.hasInputText = hasInputText;
    modalRef.componentInstance.inputTextVal = inputTextVal;
    return modalRef.result;
  }
}
